import * as S from './style';
import SocialContact from '../SocialContact';

const Footer = () => {
  return (
    <S.FooterContainer>
      <SocialContact />
      <S.CopyRight className="copyright">
        Copyright @2022 Elham Fadel. All Rights Reserved Designed By Elham Elshami
      </S.CopyRight>
    </S.FooterContainer>
  );
};
export default Footer;
